export var BriefCadence;
(function (BriefCadence) {
    BriefCadence["DAILY"] = "daily";
    BriefCadence["WEEKLY"] = "weekly";
})(BriefCadence || (BriefCadence = {}));
export var BriefStatus;
(function (BriefStatus) {
    BriefStatus["GENERATING"] = "generating";
    BriefStatus["READY"] = "ready";
    BriefStatus["FAILED"] = "failed";
    BriefStatus["EMPTY"] = "empty";
})(BriefStatus || (BriefStatus = {}));
